// @flow

import { type PendingIncomingPayment } from './types';

function getCipUrl(incomingPayment: PendingIncomingPayment): ?string {
  return incomingPayment['cip_url'];
}

export function getSafeCipUrl(incomingPayment: PendingIncomingPayment): string {
  const cipUrl = getCipUrl(incomingPayment);
  if (!cipUrl)
    throw new Error('getSafeCipUrl - there is no cip_url in the incoming payment');
  return cipUrl;
}
